import {ga4TrackLinkEvent, ga4TrackSimpleEvent} from "../../website/webpack/modules/analytics";

$(document).ready(function() {
    $('.outer-menu-open').click(function() {
        let button = $(this);
        openOuterMenu(button.data('menu'));
    });
    loadAutoloadOuterMenus();

    /** Track link click */
    $(document).on('mouseup', '.ga4-track-link', function() {
        ga4TrackLinkEvent(this);
    });
    $(document).on('click', '.ga4-track-link-click', function() {
        ga4TrackLinkEvent(this);
    });
});

function openOuterMenu(menuId)
{
    window.removeEventListener('click', handleOutsideClick);

    let container = document.querySelector('#outer-menu-container');
    if (!container) return;
    let isDynamic = container.classList.contains('outer-menu-dynamic');
    let menu = container.querySelector(`.outer-menu[data-id="${menuId}"]`);

    if (!menu && isDynamic) return getOuterMenu(menuId);

    if (menu.classList.contains('show')) return closeOuterMenu();
    container.querySelectorAll('.outer-menu.show').forEach((menuToHide) => menuToHide.classList.remove('show'));
    menu.classList.add('show');

    $(container).slideDown(200);
    setTimeout(() => window.addEventListener('click', handleOutsideClick), 0);
    ga4TrackSimpleEvent(
        {
            event: 'desktop_menu',
            method: 'open'
        }
    );
}

function closeOuterMenu()
{
    let container = document.querySelector('#outer-menu-container');
    $(container).slideUp(200, function() {
        container.querySelectorAll('.outer-menu.show').forEach((menuToHide) => menuToHide.classList.remove('show'));
    });

    window.removeEventListener('click', handleOutsideClick);
    ga4TrackSimpleEvent(
        {
            event: 'desktop_menu',
            method: 'close'
        }
    );
}

function handleOutsideClick(e) {
    detectOutsideClick(e);
}

function detectOutsideClick(event)
{
    if (!document.getElementById('outer-menu-container').contains(event.target)) closeOuterMenu();
}

function loadAutoloadOuterMenus()
{
    let container = $('#outer-menu-container');
    if (!container.hasClass('autoload-outer-menu')) return;

    $.ajax({
        url: '/ajax/outer-menu/get-menus',
        type: 'POST',
        success: function(data) {
            if (!data.html) return;
            $('#outer-menu-container').html(data.html);
        },
    });
}

let ajaxGetOuterMenu = null;
function getOuterMenu(id)
{
    if (ajaxGetOuterMenu) ajaxGetOuterMenu.abort();
    showLoader();
    let container = $('#outer-menu-container');
    ajaxGetOuterMenu = $.ajax({
        url: '/ajax/outer-menu/get-menu',
        type: 'POST',
        data: {id: id},
        success: function(data) {
            ajaxGetOuterMenu = null;
            if (!data.html) return;
            container.html(data.html);
            openOuterMenu(id);
        },
        error: function (data) {
            ajaxGetOuterMenu = null;
            hideLoader();
        }
    });
}

function showLoader()
{
    let container = $('#outer-menu-container');
    container.append('<div class="outer-menu-loader"><div class="swiper-lazy-preloader loader"></div></div>');
    container.slideDown(200);
}

function hideLoader()
{
    $('#outer-menu-container').find('.outer-menu-loader').remove();
}